import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { inject } from 'mobx-react'
import { Col, Button, Collapse, Icon, Modal } from 'antd'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import _get from 'lodash/get'
import _groupBy from 'lodash/groupBy'
import moment from 'moment'
import localeGet from '~/App/utils/localeGet'
@inject('i18n')
@injectIntl
export default class EntryFee extends Component {
  handleRedirectTo = ({path, enterNotice}) => {
    const {history, intl, i18n: { locale }} = this.props
    if (enterNotice) {
      Modal.confirm({
        title: intl.formatMessage({ id: 'app.notice' }),
        content: localeGet(enterNotice, '', locale),
        onOk () {
          history.push(path)
        }
      })
    } else {
      history.push(path)
    }
  }
  render () {
    const {
      isRegOpen,
      hideDate,
      isSoldOut,
      startDate,
      endDate,
      registrationTypes = [],
      priceSource,
      // location,
      ticketTypes = [],
      periods = [],
      slug,
      // liveLegacy,
      // website,
      customMessage,
      enterNotice,
      settings,
      i18n
    } = this.props
    const { locale } = i18n
    let items = ticketTypes
    if (priceSource && priceSource === 'registration') {
      const regTypeItems = []
      registrationTypes.forEach(regType => {
        _get(regType, 'periodIds', []).forEach(periodId => {
          const item = {
            ...regType,
            periodId
          }
          regTypeItems.push(item)
        })
      })
      items = regTypeItems
    }
    const types = _groupBy(items, 'periodId')

    function toDate (time) {
      return moment(time).format('D MMMM YYYY')
    }

    const $soldOutButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        <FormattedMessage id="app.soldOut" defaultMessage="Sold Out"/>
      </Button>
    )
    const $regUpcomingButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        <FormattedMessage id="app.regUpcoming" defaultMessage="Registration Upcoming"/>
      </Button>
    )
    const $lottoUpcomingButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        {{ en: 'Pending Lotto Results', zh: 'Pending Lotto Results', th: 'รอการประกาศผล' }[locale]}
      </Button>
    )
    const $regClosedButton = (
      <Button
        type="primary"
        disabled
        style={{ margin: '16px', fontSize: '20px' }}
      >
        <FormattedMessage id="app.regClosed" defaultMessage="Registration Closed"/>
      </Button>
    )
    const $preRegisterButton = (
      <Link to={`/${slug}/register`} className="entryFeeRegistraterBtn baseBtn">
        {{ en: 'Pre-Register', zh: 'Pre-Register', th: 'กรอกข้อมูลล่วงหน้า' }[locale]}
      </Link>
    )
    const $lottoButton = ( // TODO: Generalize lotto
      <Link to={`/${slug}/register`} className="entryFeeRegistraterBtn baseBtn">
        {{ en: 'General Registration', zh: 'General Registration', th: 'สมัครนักวิ่งทั่วไป' }[locale]}
      </Link>
    )
    const $registerButton = (
      <Button onClick={ () => this.handleRedirectTo({path: `/${slug}/register`, enterNotice})} className="entryFeeRegistraterBtn baseBtn">
        <FormattedMessage id="app.register" defaultMessage="Register"/>
      </Button>
    )

    const $checkResultsButton = (
      <Link to="/dashboard" className="entryFeeRegistraterBtn baseBtn">
        {{ en: 'Check Results', zh: 'Check Results', th: 'ตรวจสอบผลการสมัคร' }[locale]}
      </Link>
    )

    return <Col md={{ span: 8, push: 16 }}>
      <div className="side_bar">
        <div className="no_pd">
          <div className="fee_title_line">
            <span className="title">
              <FormattedMessage id="app.entryFees" defaultMessage="Entry Fees" />
            </span>
          </div>
          {periods
            .filter(
              period => types[period._id] && types[period._id].length
            )
            .sort(period => moment().isBetween(period.start, period.end) ? -1 : 1)
            .map(period => {
              const isCurrent = moment().isBetween(period.start, period.end)
              const isPreRegister = moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
              const beforeRegister = moment().isBefore(period.start)
              const afterRegister = moment().isAfter(period.end)
              
              let $actionButton
              if (isSoldOut) {
                $actionButton = $soldOutButton
              } else if (afterRegister) {
                $actionButton = $regClosedButton
              } else if (isPreRegister) {
                $actionButton = slug === 'BS21-2018-General' ? $lottoButton : $preRegisterButton
              } else if (beforeRegister) {
                $actionButton = slug === 'BS21-2018-General' ? $lottoUpcomingButton : $regUpcomingButton
              } else if (isCurrent) {
                $actionButton = slug === 'BS21-2018-General' ? $checkResultsButton : $registerButton
              } else if (!isRegOpen) {
                $actionButton = $regClosedButton
              }

              const ticketTypes = _get(types, period._id, []).sort((a, b) => a.order - b.order).filter(t => !t.hideOnFrontPage)
              if (ticketTypes.length === 0) {
                return <div key={period._id} />
              }
              // TODO: generalize lotto
              const start = slug === 'BS21-2018-General' ? period.preRegisterStart : period.start
              const end = slug === 'BS21-2018-General' ? period.preRegisterEnd : period.end
              return (
                <div key={period._id} style={{ borderTop: '3px solid grey', marginTop: '21px' }}>
                  <div className="period_box">
                    <span className="period">
                      {localeGet(period, 'name', locale)}
                    </span>
                    <p>
                      {moment(start).format('D MMM YYYY H.mm')}
                      {' '}
                        -
                      {' '}
                      {moment(end).format('D MMM YYYY H.mm')}
                      <br />
                      {localeGet(settings, 'ui.entryFee.customMessage', locale) || <FormattedMessage id="app.closeWhenFull" defaultMessage="or when fully registered" />}
                    </p>
                  </div>
                  <Collapse defaultActiveKey={['1']} bordered={false} style={{ background: 'none', color: 'white' }} onChange={console.log}>
                    <Collapse.Panel key="1" showArrow={false} style={{ border: 'none' }} header={
                      <React.Fragment>
                        <div className="ant-dropdown-link entryFeeBnt ant-dropdown-trigger">
                          <FormattedMessage
                            id="app.entryFee"
                            defaultMessage="Entry Fee"
                          />
                          <Icon type="down"/>
                        </div>
                      </React.Fragment>}
                    >
                      <table className="entryFee" >
                        <thead>
                          <tr>
                            <td>
                              <FormattedMessage
                                id="app.raceType"
                                defaultMessage="Race Type"
                              />
                            </td>
                            <td className="fee">
                              <FormattedMessage
                                id="app.entryFee"
                                defaultMessage="Entry Fee"
                              />
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {ticketTypes.map(ticketType => {
                            return (
                              <tr
                                key={ticketType._id}
                                className="entryFreeNameAndPrice"
                              >
                                <td >{localeGet(ticketType, 'name', locale)}</td>
                                <td className="fee">{<FormattedNumber value={ticketType.price} />}&nbsp;THB</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </Collapse.Panel>
                  </Collapse>
                  <div>
                    {$actionButton}
                  </div>
                </div>
              )
            })}
          {customMessage &&
            <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>{_get(customMessage, locale)}</div>
          }
        </div>
      </div>
      {!hideDate && <div className="side_bar">
        <span className="title">
          <FormattedMessage id="app.details" defaultMessage="Details" />
        </span>
        <div className="detailTitle">
          <FormattedMessage id="app.race_day" defaultMessag="Race Day" />
        </div>
        <div className="detailInfo">{toDate(startDate)} {endDate && `- ${toDate(endDate)}`}</div>
      </div>}
    </Col>
  }
}



// WEBPACK FOOTER //
// ./src/App/EventPage/Components/EntryFee.js